import React from 'react';
import KickImage from 'Reuseables/KickImage';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { Container, Row, Col } from 'reactstrap';

const ToggleHolidayMode = (props) => (
  // <Container>
    // <Row>
      <div className="switch__wrapper">
        <div
          onClick={props.onClick}
          className={classNames("switch__wrapper_background", {"holidays": props.holidays})}
        >
          { props.holidays&&props.active?
              <i className="fa fa-check"/> : null
          }
          <div
            className={classNames("switch__wrapper_background_circle",
              `circle_${props.color}`,
              {"active": props.active}, {"holidays-mode": props.holidays})}
            style={ props.style }
          />
          { 
              !props.active?
              <span className="off-holidays">I</span> : null
          }
        </div>
      </div>
    // </Row>
  /* </Container> */

)

ToggleHolidayMode.defaultProps = {
  color: 'green',
  active: false
}

ToggleHolidayMode.propTypes = {
  style: propTypes.object,
  title: propTypes.string,
  onClick: propTypes.func,
  active: propTypes.bool,
  color: propTypes.oneOf(['green'])
}

export default ToggleHolidayMode;